import { TableUrlParams, TransformResponseType } from 'Core/interfaces'
import { Http } from 'Core/utils/axios'

import { Document } from 'Portals/Supplier/entities'

import { baseUrl } from './constants'

export const getList = (params: TableUrlParams): Promise<ListData<Document.Basic>> =>
	Http.get(baseUrl, { params })

export const retrieveTypes = (): Promise<Document.Type[]> => Http.get(`${baseUrl}/types`)

export const retrieveStatuses = (): Promise<Entity[]> => Http.get(`${baseUrl}/statuses`)

export const retrieveDocumentsBySupplier = ({
	supplierId,
	documentTypeId
}: {
	supplierId: Key
	documentTypeId: Key
}): Promise<Document.Detailed[]> =>
	Http.get(`${baseUrl}/${supplierId}/document-types/${documentTypeId}`)

export const downloadDocumentBySupplier = (
	supplierId: Key,
	supplierDocumentId: Key
): Promise<TransformResponseType> =>
	Http.get(`${baseUrl}/${supplierId}/download/${supplierDocumentId}`, {
		responseType: 'blob',
		transformResponse: (data: Blob, headers) => ({
			data,
			headers
		})
	})

export const retrieveDocumentsByLocation = ({
	supplierLocationId,
	documentTypeId
}: {
	supplierLocationId: Key
	documentTypeId: Key
}): Promise<Document.Detailed[]> =>
	Http.get(`${baseUrl}/locations/${supplierLocationId}/document-types/${documentTypeId}`)

export const downloadDocumentByLocation = (
	supplierLocationId: Key,
	supplierDocumentId: Key
): Promise<TransformResponseType> =>
	Http.get(`${baseUrl}/locations/${supplierLocationId}/download/${supplierDocumentId}`, {
		responseType: 'blob',
		transformResponse: (data: Blob, headers) => ({
			data,
			headers
		})
	})

export const retrieveSuppliers = (): Promise<Entity[]> => Http.get('/suppliers')

export const retrieveSupplierLocations = (): Promise<Entity[]> => Http.get('supplier-locations')

export const retrieveDocumentTypes = (): Promise<Document.Type[]> => Http.get(`${baseUrl}/types`)

export const addDocumentBySupplier = (
	supplierId: Key,
	payload: Document.Add.Request
): Promise<Document.Basic> => {
	return Http.post(`${baseUrl}/${supplierId}`, payload, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
}

export const addDocumentBySupplierLocation = (
	supplierLocationId: Key,
	payload: Document.Add.Request
): Promise<Document.Basic> => {
	return Http.post(`${baseUrl}/locations/${supplierLocationId}`, payload, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
}
